"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("history");
var history = history_1.createBrowserHistory();
exports.default = history;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/shared/history.ts
// module id = 159
// module chunks = 0